export const CORPORATE_CLIENTS = "CORPORATE_CLIENTS"